import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import * as NumberUtils from '@/utils/NumberUtils'
import { cacheName, cache } from '@/utils/cacheManager'
import lodash from 'lodash'
import $store from '@/store'
import DateUtils from '@/utils/dateUtils'
import { getUuid } from '@/utils'
import { sortByMultiField } from '@/utils'
import { Message } from '@/utils/Message'
import lang from '@/lang'
import {
  CHARGE_SOURCE_DIFFERENCE_PROCESSING,
  CHARGE_SOURCE_SPLIT
} from '@/class/cargo/model/parameters/SystemConstants'
import { getContactList } from '@/api/partner/contact'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getTitleBankList } from '@/api/partner/titleBank'
import { Company } from '@/class/model/mdm/Company'

export const ADD_JUST = 0

export const EDIT_JUST = 1

export const DEL_JUST = 2

/**
 * 批量确认业务
 */
export function confirmJobs(jobs) {
  for (let i = 0; i < jobs.length; i++) {
    const job = jobs[i]
    if (job['jobConfirmState'] === 0) {
      if (job.hasOwnProperty('charges')) {
        const charges = job.charges
        if (charges && charges.length > 0) {
          const count = confirmCharges(charges, job)
          job['jobDifferenceAmount'] = Number(job['jobChargeAmountTotal']) - Number(job['jobBillingAmount'])
          if (charges.length === count) {
            job['jobConfirmState'] = ChargeConstants.CONFIRM_STATE_CONFIRMED.code
          }
        }
      }
    }
  }
}

/**
 * 批量确认费用
 */
export function confirmCharges(charges, job = null) {
  let count = 0
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    if (charge['chargeConfirmState'] === 0 && charge['chargeVerifiedAmount'] === 0) {
      count++
      charge['chargeBillingAmount'] = charge['chargeAmount']
      charge['chargeDiffAmount'] = 0
      charge['chargeConfirmState'] = ChargeConstants.CONFIRM_STATE_CONFIRMED.code
      charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      charge['chargeConfirmUser'] = $store.getters.userId
      charge['dirty'] = true
      if (job != null) {
        job['jobBillingAmount'] += charge['chargeAmount']
      }
    }
  }
  return count
}

/**
 * 批量取消确认业务
 */
export function cancelConfirmJobs(jobs) {
  for (let i = 0; i < jobs.length; i++) {
    const job = jobs[i]
    if (job.hasOwnProperty('charges')) {
      const charges = job['charges']
      if (charges && charges.length > 0) {
        const count = cancelConfirmCharges(charges, job)
        job['jobDifferenceAmount'] = Number(job['jobChargeAmountTotal']) - Number(job['jobBillingAmount'])
        if (charges.length === count) {
          job['jobConfirmState'] = ChargeConstants.CONFIRM_STATE_UNCONFIRM.code
        }
      }
    }
  }
}

/**
 * 批量取消确认费用
 */
export function cancelConfirmCharges(charges, job = null) {
  let count = 0
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    if (charge['chargeConfirmState'] === ChargeConstants.CONFIRM_STATE_CONFIRMED.code && (charge['chargeDifferentState'] === 0 || charge['chargeDifferentState'] === 3)) {
      charge['chargeConfirmState'] = ChargeConstants.CONFIRM_STATE_UNCONFIRM.code
      charge['chargeConfirmDate'] = null
      charge['chargeConfirmUser'] = 0
      charge['chargeBillingAmount'] = 0
      charge['chargeDiffAmount'] = charge['chargeAmount']
      charge['dirty'] = true
      if (job) {
        job['jobBillingAmount'] -= charge['chargeAmount']
      }
      count++
    }
  }
  return count
}

/**
 * 删除业务费用
 */
export function removeJobCharges(charge, job) {
  const removeItems = []
  const charges = job['charges']
  if (charges && charges.length > 0) {
    for (let i = charges.length - 1; i >= 0; i--) {
      const chargeItem = charges[i]
      if (charge['uuid'] === chargeItem['uuid']) {
        removeItems.push(charge)
        charges.splice(i, 1)
        job['jobBillingAmount'] = NumberUtils.ToFixed2(job['jobBillingAmount'] - chargeItem['chargeBillingAmount'], 2)
        job['jobChargeAmountTotal'] = NumberUtils.ToFixed2(job['jobChargeAmountTotal'] - chargeItem['chargeAmount'], 2)
        job['jobDifferenceAmount'] = NumberUtils.ToFixed2(job['jobChargeAmountTotal'] - job['jobBillingAmount'], 2)
      }
    }
  }
  return removeItems
}

/**
 * 处理业务上的费用差额
 */
export async function processJobDiffAmount(jobs, callBack) {
  let diffCharges = []
  for (let i = 0; i < jobs.length; i++) {
    const job = jobs[i]
    const charges = job['charges']
    if (job['jobBillingAmount'] !== 0 && charges && charges.length > 0) {
      const list = await processChargeDiffAmount(charges, callBack)
      if (list && list.length > 0) {
        diffCharges = diffCharges.concat(list)
        job['jobConfirmState'] = 1
      }
    }
  }
  return diffCharges
}

/**
 * 处理费用差额
 */
export async function processChargeDiffAmount(charges, callBack) {
  const diffCharges = []
  await cache.load(cacheName.CONFIG)
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    const verifiedAmount = charge['chargeVerifiedAmount']
    const billingAmount = charge['chargeBillingAmount']
    const amount = charge['chargeAmount']
    const confirmState = charge['chargeConfirmState']
    const differentState = charge['chargeDifferentState']

    const diffChargeByBillingAmountPattern = Number(cache.config.get('DiffChargeByBillingAmountPattern'))
    const chargeAmount = Math.abs(charge['chargeAmount'])// 取绝对值后的费用金额
    const billingAmountNew = Math.abs(billingAmount)// 取绝对值后的对账金额
    if (!charge['uuid']) {
      callBack()
      break
    }
    if (verifiedAmount === 0 && billingAmount !== 0) {
      if (amount === billingAmount && confirmState === 0) {
        charge['dirty'] = true
        charge['chargeConfirmState'] = 1
        charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
        charge['chargeConfirmUser'] = $store.getters.userId
      } else if (amount !== billingAmount && (differentState === 0 || differentState === 3)) {
        let value = 0
        charge['dirty'] = true
        if (diffChargeByBillingAmountPattern === 1) {
          if ((chargeAmount < billingAmountNew) || (amount > 0 && billingAmount < 0) || (amount < 0 && billingAmount > 0)) {
            Message.warning(lang.t('act.billing.reconciliationAmountNotSupport'))
            break
          } else {
            if (amount > billingAmount && amount > 0) {
              value = amount - billingAmount
            } else if (chargeAmount > billingAmountNew && amount < 0) {
              value = -(chargeAmount - billingAmountNew)
            } else if (amount === billingAmount) {
              value = -amount
            } else {
              charge['chargeConfirmState'] = 1
              charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
              charge['chargeConfirmUser'] = $store.getters.userId
              continue
            }
          }
        } else {
          if (amount > billingAmount) {
            value = amount - billingAmount
          } else if (amount === billingAmount) {
            value = -amount
          } else {
            value = billingAmount - amount
          }
        }
        charge['chargeConfirmState'] = 1
        charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
        charge['chargeConfirmUser'] = $store.getters.userId
        charge['chargeDifferentState'] = 1
        value = NumberUtils.ToFixed2(value, 2)
        let positiveCharge = {}
        let minusCharge = {}
        if ((chargeAmount > billingAmountNew && amount > 0) || diffChargeByBillingAmountPattern === 0) {
          positiveCharge = generateDiffCharge(value, charge)
          minusCharge = generateDiffCharge(-value, charge)
        } else {
          positiveCharge = generateDiffCharge(-value, charge)
          minusCharge = generateDiffCharge(value, charge)
        }
        positiveCharge['relatedId'] = charge['chargeChargeId']
        positiveCharge['chargeSource'] = CHARGE_SOURCE_DIFFERENCE_PROCESSING.code
        minusCharge['relatedId'] = charge['chargeChargeId']
        minusCharge['chargeSource'] = CHARGE_SOURCE_DIFFERENCE_PROCESSING.code
        if (amount >= billingAmount) {
          positiveCharge['chargeConfirmRemarks'] = ''
          positiveCharge['chargeDifferentState'] = 3
          minusCharge['chargeDifferentState'] = 2
          minusCharge['chargeConfirmState'] = 1
          minusCharge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
          minusCharge['chargeConfirmUser'] = $store.getters.userId
        } else {
          minusCharge['chargeConfirmRemarks'] = ''
          minusCharge['chargeDifferentState'] = 3
          positiveCharge['chargeDifferentState'] = 2
          positiveCharge['chargeConfirmState'] = 1
          positiveCharge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
          positiveCharge['chargeConfirmUser'] = $store.getters.userId
        }
        if (positiveCharge['chargeAmount'] !== 0) {
          diffCharges.push(positiveCharge)
        }
        if (minusCharge['chargeAmount'] < 0) {
          diffCharges.push(minusCharge)
        }
      }
    }
  }
  return diffCharges
}

/**
 * 生成正数费用
 */
export function generateDiffCharge(amount, origin) {
  const charge = createDiffCharge(origin)
  charge['originUuid'] = origin['uuid']
  charge['chargeAmount'] = NumberUtils.ToFixed2(amount, 2)
  charge['chargeExcludingTaxAmount'] = NumberUtils.ToFixed2(NumberUtils.ToFixed2(charge['chargeAmount'] * 100, 2) / (100 + charge['chargeTaxRate']), 2)
  charge['chargeTaxAmount'] = NumberUtils.ToFixed2(charge['chargeAmount'] - charge['chargeExcludingTaxAmount'], 2)
  charge['chargeDiffAmount'] = charge['chargeAmount']
  charge['chargeUnitRate'] = charge['chargeAmount']
  charge['chargeUnverifiedAmount'] = NumberUtils.ToFixed2(charge['charge_amount'] - charge['chargeVerifiedAmount'], 2)
  charge['invoiceUuid'] = origin['invoiceUuid']
  charge['chargeInvoiceNo'] = origin['chargeInvoiceNo']
  charge['chargeInvoiceAmount'] = origin['chargeInvoiceAmount']
  charge['chargeInvoiceExcludingTax'] = origin['chargeInvoiceExcludingTax']
  charge['chargeInvoiceTax'] = origin['chargeInvoiceTax']
  return charge
}

/**
 * 生成差额费用
 */
export function createDiffCharge(origin) {
  const charge = {}
  for (const key in origin) {
    if (key.indexOf('job') === 0) {
      charge[key] = origin[key]
    }
  }
  charge['entity'] = 'charge'
  charge['uuid'] = null
  charge['version'] = 1
  charge['billingUuid'] = origin['billingUuid']
  charge['billingNo'] = origin['billingNo']
  charge['chargeDiffChargeUuid'] = origin['uuid']
  charge['chargeAccountId'] = origin['chargeAccountId']
  charge['chargeBranchId'] = origin['chargeBranchId']
  charge['chargeOversea'] = origin['chargeOversea']
  charge['chargeChargeItemId'] = origin['chargeChargeItemId']
  charge['chargeReceivable'] = origin['chargeReceivable']
  charge['chargeCurrency'] = origin['chargeCurrency']
  charge['chargeMeasure'] = origin['chargeMeasure']
  charge['chargeExchangeRate'] = origin['chargeExchangeRate']
  charge['chargeAmount'] = origin['chargeAmount']
  charge['chargeExcludingTaxAmount'] = origin['chargeExcludingTaxAmount']
  charge['chargeTaxRate'] = origin['chargeTaxRate']
  charge['chargeConfirmRemarks'] = origin['chargeConfirmRemarks']
  charge['chargeChargeState'] = origin['chargeChargeState']
  charge['chargeAccountingDate'] = origin['chargeAccountingDate']
  charge['chargeContactPerson'] = origin['chargeContactPerson']
  charge['chargeQuantity'] = 1
  charge['chargeUnitRate'] = 1
  charge['chargeInputBy'] = $store.getters.userId
  charge['chargeInputDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
  charge['chargeAuditor'] = $store.getters.userId
  charge['chargeTaxAmount'] = 0
  charge['chargeVerifiedAmount'] = 0
  charge['chargeBillingAmount'] = 0
  charge['chargeConfirmState'] = 0
  charge['chargeOffsetState'] = 0
  charge['chargeAdjustment'] = origin['chargeAdjustment']
  charge['chargeAdvance'] = origin['chargeAdvance']
  charge['chargeCommission'] = origin['chargeCommission']
  charge['chargePrepaid'] = origin['chargePrepaid']
  charge['chargeRelatedId'] = origin['chargeRelatedId']
  charge['chargeBusinessDate'] = origin['chargeBusinessDate']
  return charge
}

/**
 * 拆分费用
 */
export async function splitCharges(charges, alertCall) {
  const diffCharges = []
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    const amount = Number(charge['chargeAmount'])
    const billingAmount = Number(charge['chargeBillingAmount'])
    charge['chargeBillingAmount'] = billingAmount
    if (!charge['billPaymentUuid'] && charge['chargeVerifiedAmount'] === 0 && billingAmount !== 0) {
      if (!charge['uuid']) {
        alertCall()
        break
      }
      await cache.load(cacheName.CONFIG)
      const diffChargeByBillingAmountPattern = Number(cache.config.get('DiffChargeByBillingAmountPattern'))
      const chargeAmountNew = Math.abs(amount)// 取绝对值后的费用金额
      const billingAmountNew = Math.abs(billingAmount)// 取绝对值后的对账金额
      let splitAmount = 0.00
      if (diffChargeByBillingAmountPattern === 1) {
        if ((chargeAmountNew < billingAmountNew) || (amount > 0 && billingAmount < 0) || (amount < 0 && billingAmount > 0)) {
          Message.warning(lang.t('act.billing.reconciliationAmountNotSupport'))
          break
        } else {
          if (amount > billingAmount && amount > 0) {
            splitAmount = amount - billingAmount
          } else if (chargeAmountNew > billingAmountNew && amount < 0) {
            splitAmount = -(chargeAmountNew - billingAmountNew)
          } else {
            charge['dirty'] = true
            charge['chargeConfirmState'] = 1
            charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
            charge['chargeConfirmUser'] = $store.getters.userId
            continue
          }
        }
      } else {
        splitAmount = NumberUtils.ToFixed2(amount - billingAmount, 2)
        if (splitAmount === 0) {
          continue
        }
      }

      const newCharge = lodash.cloneDeep(charge)
      newCharge['entity'] = 'charge'
      newCharge['chargeUuid'] = null
      newCharge['uuid'] = null
      newCharge['jobUuid'] = charge['jobUuid']
      newCharge['version'] = 1
      newCharge['originUuid'] = charge['uuid']
      newCharge['chargeDiffChargeUuid'] = charge['uuid']
      newCharge['chargeAmount'] = splitAmount
      newCharge['chargeDiffAmount'] = newCharge['chargeAmount']
      newCharge['chargeExcludingTaxAmount'] = NumberUtils.ToFixed2((newCharge['chargeAmount'] * 100) / (100 + newCharge['chargeTaxRate']), 2)
      newCharge['chargeTaxAmount'] = NumberUtils.ToFixed2(newCharge['chargeAmount'] - newCharge['chargeExcludingTaxAmount'], 2)
      newCharge['chargeUnverifiedAmount'] = NumberUtils.ToFixed2(newCharge['chargeAmount'] - newCharge['chargeVerifiedAmount'], 2)
      newCharge['chargeBillingAmount'] = 0
      newCharge['chargeOffsetState'] = 0
      newCharge['chargeRemarks'] = charge['chargeRemarks'].trim().length > 0 ? charge['chargeRemarks'] + ' ' : ''
      newCharge['chargeRelatedId'] = charge['chargeChargeId']
      newCharge['chargeSource'] = CHARGE_SOURCE_SPLIT.code
      newCharge['chargeRemarks'] += '拆分费用'
      diffCharges.push(newCharge)
      const splitPercent = charge['chargeBillingAmount'] / charge['chargeAmount']
      let billingAmountSmall = false
      if (diffChargeByBillingAmountPattern === 1) { // 0.按对账金额拆分 1.对账金额不允许大于费用金额
        billingAmountSmall = chargeAmountNew > billingAmountNew
        if (billingAmountSmall) {
          charge['chargeAmount'] = NumberUtils.ToFixed2(charge['chargeBillingAmount'], 2)
        }
      } else {
        charge['chargeAmount'] = NumberUtils.ToFixed2(charge['chargeBillingAmount'], 2)
      }
      charge['dirty'] = true
      charge['isSelect'] = false
      charge['chargeExcludingTaxAmount'] = NumberUtils.ToFixed2(charge['chargeAmount'] - charge['chargeTaxAmount'], 2)
      charge['chargeUnverifiedAmount'] = NumberUtils.ToFixed2(charge['chargeAmount'] - charge['chargeVerifiedAmount'], 2)
      charge['chargeDiffAmount'] = 0
      charge['chargeConfirmState'] = 1
      charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      charge['chargeConfirmUser'] = $store.getters.userId
      if (charge['chargeInvoiceAmount'] && billingAmountSmall) {
        const invoiceAmount = Number(charge['chargeInvoiceAmount'])
        const invoiceExcludingTax = Number(charge['chargeInvoiceExcludingTax'])
        const invoiceTax = Number(charge['chargeInvoiceTax'])

        charge['chargeInvoiceAmount'] = NumberUtils.ToFixed2(charge['chargeInvoiceAmount'] * splitPercent, 2)
        charge['chargeInvoiceExcludingTax'] = NumberUtils.ToFixed2(charge['chargeInvoiceExcludingTax'] * splitPercent, 2)
        charge['chargeInvoiceTax'] = NumberUtils.ToFixed2(charge['chargeInvoiceTax'] * splitPercent, 2)

        newCharge['invoiceUuid'] = charge['invoiceUuid']
        newCharge['chargeInvoiceNo'] = charge['chargeInvoiceNo']
        newCharge['chargeInvoiceAmount'] = NumberUtils.ToFixed2(invoiceAmount - charge['chargeInvoiceAmount'], 2)
        newCharge['chargeInvoiceExcludingTax'] = NumberUtils.ToFixed2(invoiceExcludingTax - charge['chargeInvoiceExcludingTax'], 2)
        newCharge['chargeInvoiceTax'] = NumberUtils.ToFixed2(invoiceTax - charge['chargeInvoiceTax'], 2)
      }
      if (!billingAmountSmall) {
        charge['invoiceUuid'] = null
        charge['chargeInvoiceNo'] = ''
        charge['chargeInvoiceAmount'] = 0.0
        charge['chargeInvoiceExcludingTax'] = 0.0
        charge['chargeInvoiceTax'] = 0.0
      }
    }
  }
  return diffCharges
}

/**
 * 按业务拆分费用
 */
export async function splitJobCharges(jobs, alertCall) {
  let diffCharges = []
  for (let i = 0; i < jobs.length; i++) {
    const job = jobs[i]
    const charges = job['charges']
    if (charges && charges.length > 0) {
      const result = await splitCharges(charges, alertCall)
      if (result && result.length > 0) {
        diffCharges = diffCharges.concat(result)
        job['isSelect'] = false
        job['jobConfirmState'] = 1
      }
      // 拆分完毕后，重新刷新业务上的费用总金额，对账金额，差额字段
      let totalJobBillingAmount = 0.0
      let totalJobChargeAmountTotal = 0.0
      for (let i = 0; i < charges.length; i++) {
        const charge = charges[i]
        const chargeBillingAmount = isNaN(charge['chargeBillingAmount']) ? 0.00 : Number(charge['chargeBillingAmount'])
        const chargeAmount = isNaN(charge['chargeAmount']) ? 0.00 : Number(charge['chargeAmount'])
        totalJobBillingAmount = totalJobBillingAmount + chargeBillingAmount
        totalJobChargeAmountTotal = totalJobChargeAmountTotal + chargeAmount
      }
      job['jobBillingAmount'] = NumberUtils.ToFixed2(totalJobBillingAmount, 2)
      job['jobChargeAmountTotal'] = NumberUtils.ToFixed2(totalJobChargeAmountTotal, 2)
      job['jobDifferenceAmount'] = NumberUtils.ToFixed2(totalJobChargeAmountTotal - totalJobChargeAmountTotal, 2)
    }
  }
  return diffCharges
}

/**
 * 添加业务费用
 */
export function appendJobCharges(charge, rowData) {
  // 根据分组条件去查询业务是否存在，不存在则新增一条记录
  const job = getExitsChargeJobItem(charge, rowData)
  if (!job) {
    const newJob = createJobItem(charge)
    rowData.push(newJob)
  } else {
    job['jobBillingAmount'] = NumberUtils.ToFixed2(Number(job['jobBillingAmount']) + Number(charge['chargeBillingAmount']), 2)
    job['jobChargeAmountTotal'] = NumberUtils.ToFixed2(Number(job['jobChargeAmountTotal']) + Number(charge['chargeAmount']), 2)
    job['jobDifferenceAmount'] = NumberUtils.ToFixed2(Number(job['jobChargeAmountTotal']) - Number(job['jobBillingAmount']), 2)
    if (job['charges'] && job['charges'].length > 0) {
      job['charges'].push(charge)
    } else {
      job['charges'] = []
      job['charges'].push(charge)
    }
  }
  return rowData
}

/**
 * 获取跟这条费用相同逻辑的分组
 */
export function getExitsChargeJobItem(charge, rowData) {
  for (let i = 0; i < rowData.length; i++) {
    const job = rowData[i]
    const charges = job['charges']
    if (charges && charges.length > 0) {
      const key = getJobMapKey(charges[0])
      const addKey = getJobMapKey(charge)
      if (key === addKey) {
        return job
      }
    }
  }
  return null
}

/**
 * 获取分组条件
 */
export function getJobMapKey(charge) {
  return (charge['chargeCurrency'] + charge['chargeConfirmState'] + charge['chargeReceivable'] + charge['jobUuid'])
}

/**
 * 创建job对象
 */
export function createJobItem(charge) {
  const jobItem = {}
  jobItem['entity'] = 'job'
  jobItem['isSelect'] = false
  jobItem['jobUid'] = getUuid() // 当分组条件不同时，要在业务列表在显示不同的记录，此时用到jobUid字段，作为唯一标识
  jobItem['uuid'] = charge['jobUuid']
  jobItem['jobJobNo'] = charge['jobJobNo']
  jobItem['jobJobState'] = charge['jobJobState']
  jobItem['jobMbl'] = charge['jobMbl']
  jobItem['jobVesselFlight'] = charge['jobVesselFlight']
  jobItem['jobAr'] = charge['chargeReceivable']
  jobItem['jobChargeCurrency'] = charge['chargeCurrency']
  jobItem['jobConfirmState'] = charge['chargeConfirmState']
  jobItem['jobBillingAmount'] = charge['chargeBillingAmount']
  jobItem['jobChargeAmountTotal'] = charge['chargeAmount']
  jobItem['jobDifferenceAmount'] = NumberUtils.ToFixed2(jobItem['jobChargeAmountTotal'] - jobItem['jobBillingAmount'], 2)
  jobItem['jobBookingAgent'] = charge['jobBookingAgent']
  jobItem['jobCarrierId'] = charge['jobCarrierId']
  jobItem['jobCustomerId'] = charge['jobCustomerId']
  jobItem['jobDischargingPortCode'] = charge['jobDischargingPortCode']
  jobItem['jobEtd'] = charge['jobEtd']
  jobItem['jobLob'] = charge['jobLob']
  jobItem['jobOp'] = charge['jobOp']
  jobItem['jobSales'] = charge['jobSales']
  jobItem['jobSoNo'] = charge['jobSoNo']
  jobItem['jobImportHbl'] = charge['jobImportHbl']
  jobItem['containerContainerNo'] = charge['jobContainerNo']
  jobItem['jobCustomJobType'] = charge['jobCustomJobType']
  jobItem['charges'] = [charge]
  return jobItem
}

/**
 * 费用调整验证
 */
export function checkJustChargeJob(item) {
  if (item['jobJobState'] > 0) {
    Message.warning(lang.t('CargoMsg.Cargo_JobStateNotAllowModified'))
    return false
  }
  return true
}

/**
 * 费用调整验证
 */
export function checkJustCharge(item) {
  if (item['chargeDifferentState'] > 0 && item['chargeDifferentState'] < 3) {
    Message.warning(lang.t('CargoMsg.Cargo_ChargeHasDiffAmount'))
    return false
  }
  if (item['chargeConfirmState'] > 0) {
    Message.warning(lang.t('CargoMsg.Cargo_ChargeHasConfirm'))
    return false
  }
  if (item['chargeVerifiedAmount'] !== 0) {
    Message.warning(lang.t('CargoMsg.Cargo_ChargeHasVerified'))
    return false
  }
  if (item['chargeChargeState'] === 1) {
    Message.warning(lang.t('CargoMsg.Cargo_ChargeHasCommit'))
    return false
  }
  if (item['billPaymentUuid']) {
    Message.warning(lang.t('CargoMsg.Cargo_ChargeHasCreateBillPayment'))
    return false
  }
  if (item['invoiceUuid']) {
    Message.warning(lang.t('CargoMsg.Cargo_ChargeHasCreateInvoice'))
    return false
  }
  if (item['jobJobState'] > 0) {
    Message.warning(lang.t('CargoMsg.Cargo_JobStateNotAllowModified'))
    return false
  }
  return true
}

/**
 * 按业务查询  校验该笔业务下 费用的状态
 * @param item
 * @returns {boolean}
 */

export function checkJobCharge(item) {
  for (let i = 0; i < item.charges.length; ++i) {
    const charge = item.charges[i]
    if (charge['chargeDifferentState'] > 0 && charge['chargeDifferentState'] < 3) {
      Message.warning(lang.t('CargoMsg.Cargo_ChargeHasDiffAmount'))
      return false
    }
    if (charge['chargeConfirmState'] > 0) {
      Message.warning(lang.t('CargoMsg.Cargo_ChargeHasConfirm'))
      return false
    }
    if (charge['chargeVerifiedAmount'] !== 0) {
      Message.warning(lang.t('CargoMsg.Cargo_ChargeHasVerified'))
      return false
    }
    if (charge['chargeChargeState'] === 1) {
      Message.warning(lang.t('CargoMsg.Cargo_ChargeHasCommit'))
      return false
    }
    if (charge['billPaymentUuid']) {
      Message.warning(lang.t('CargoMsg.Cargo_ChargeHasCreateBillPayment'))
      return false
    }
    if (charge['invoiceUuid']) {
      Message.warning(lang.t('CargoMsg.Cargo_ChargeHasCreateInvoice'))
      return false
    }
  }
  if (item['jobJobState'] > 0) {
    Message.warning(lang.t('CargoMsg.Cargo_JobStateNotAllowModified'))
    return false
  }
  return true
}

/**
 * 按币种，确认状态，业务进行分组
 */
export function getGroupByChargeJobs(charges, isAr) {
  const jobCurrency = {}
  const jobList = []
  let job = null
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    const key = getJobMapKey(charge)
    if (!jobCurrency.hasOwnProperty(key)) {
      job = createJobItem(charge)
      jobCurrency[key] = job
      jobList.push(job)
    } else {
      job = jobCurrency[key]
      if (job) {
        job['jobBillingAmount'] = NumberUtils.ToFixed2(job['jobBillingAmount'] + charge['chargeBillingAmount'], 2)
        job['jobChargeAmountTotal'] = NumberUtils.ToFixed2(job['jobChargeAmountTotal'] + charge['chargeAmount'], 2)
        job['jobDifferenceAmount'] = NumberUtils.ToFixed2(job['jobChargeAmountTotal'] - job['jobBillingAmount'], 2)
        if (!job['charges']) {
          job['charges'] = []
        }
        job['charges'].push(charge)
      }
    }
  }
  return jobList
}

/**
 * 分摊对账金额
 */
export function shareJobBillingAmount(job) {
  let charges = job['charges']
  if (!charges) { return }

  let charge = null
  if (charges.length === 1) {
    charge = charges[0]
    charge['chargeBillingAmount'] = Number(job['jobBillingAmount'])
  } else {
    charges = sortByMultiField(charges, ['chargeAmount'], false)
    let billingAmount = Number(job['jobBillingAmount'])
    const len = charges.length
    let isBreak = false
    for (let i = 0; i < len; i++) {
      charge = charges[i]
      if (i === len - 1 || billingAmount <= charge['chargeAmount']) {
        charge['chargeBillingAmount'] = billingAmount
        billingAmount = 0
        isBreak = true
      }
      if (!isBreak) {
        charge['chargeBillingAmount'] = (billingAmount - charge['chargeAmount']) > 0 ? charge['chargeAmount'] : charge['chargeAmount'] - billingAmount
        billingAmount -= Number(charge['chargeAmount'])
      }
    }
  }
}

/**
 * 汇总费用的总差额
 */
export async function sumChargeDiffAmount(job) {
  const charges = job['charges']
  if (!charges) { return 0 }

  let total = 0.00
  let totalChargeAmount = 0.00
  let billingAmount = 0.00// 输入的对账金额
  for (let i = 0; i < charges.length; i++) {
    const charge = charges[i]
    total = total + charge['chargeAmount'] - charge['chargeBillingAmount']
    totalChargeAmount += charge['chargeAmount']
    billingAmount += charge['chargeBillingAmount']
  }

  await cache.load(cacheName.CONFIG)
  const diffChargeByBillingAmountPattern = Number(cache.config.get('DiffChargeByBillingAmountPattern'))
  const chargeAmount = Math.abs(totalChargeAmount)// 取绝对值后的费用总金额
  const billingAmountNew = Math.abs(billingAmount)// 取绝对值后的对账金额
  if (diffChargeByBillingAmountPattern === 1) {
    if ((chargeAmount < billingAmountNew) || (totalChargeAmount > 0 && billingAmount < 0) || (totalChargeAmount < 0 && billingAmount > 0)) {
      job['jobBillingAmount'] = 0.00
      Message.warning('您输入的对账金额不合理！')
      return job['jobChargeAmountTotal']
    } else {
      if (totalChargeAmount > 0) {
        total = totalChargeAmount - billingAmount
      } else {
        total = -(chargeAmount - billingAmountNew)
      }
    }
  }
  return NumberUtils.ToFixed2(total, 2)
}
// 获取结算代理
export async function querySettlementAgentList(accountId, account = null, hasSettlement = false, billing) {
  let settlementAgentId = 0
  const settlementAgentArray = await getSettlementAgentsByCmpIdx(accountId).then((res) => { return res.data })
  if (settlementAgentArray && settlementAgentArray.length > 0) {
    if (!hasSettlement) {
      const settlementAgent = settlementAgentArray[0]
      settlementAgentId = settlementAgent['cmpIdx']
    } else {
      settlementAgentId = isNaN(billing.settlementAgentId) ? 0 : billing.settlementAgentId
    }
  } else {
    if (!hasSettlement) {
      settlementAgentId = accountId
    } else {
      settlementAgentId = billing.settlementAgentId
    }
  }
  if (!billing.uuid && !this.isView && (billing.settlementAgentId === 0 || !billing.settlementAgentId)) {
    billing.settlementAgentId = settlementAgentId
  }
}
// 查询结算对象联系人
export async function queryAccountContact(accountId, billing) {
  if (accountId > 0) {
    await getContactList({ cmpIdx: accountId }).then((res) => {
      let contacts = []
      if (res.data && res.data.list.length > 0) {
        contacts = res.data.list
      }
      if (contacts.length > 0) {
        if (!billing.uuid) { // 新增的时候，默认带出联系人信息
          for (const contact of contacts) {
            if (contact.defaultContact) {
              billing.accountContacts = contact.contactPerson
              billing.accountContactsTel = contact.telephone
              break
            }
          }
        }
      }
    })
  }
}

export async function initBillingInformation(billing = null) {
  // 新建账单，并且账单结算对象存在的时候
  if (!billing || billing.uuid || !billing.accountId) return
  // 获取结算对象的开票抬头(如果旧值为0，说明是第一次初始化，将直接用传递进来的发票抬头)
  await getBillingTitle(billing) // 一定要保证先查询开票抬头，然后再根据开票抬头去查询开票银行
}

export async function getBillingTitle(billing = null) {
  if (!billing || billing.accountId <= 0) return
  await queryTitleByCpmIdx(billing.accountId).then(async res => {
    let titleArray = []
    if (res.data && res.data.length > 0) { titleArray = res.data }
    const title = billing.title || ''
    const buyerTaxAccount = billing.buyerTaxAccount || ''
    // 记录开票抬头UUID
    let invoiceTitleUuid = ''
    if (title) {
      const titles = titleArray.filter(t => t.title === title)
      if (titles.length === 1) {
        invoiceTitleUuid = titles[0].uuid
        setBillingTitle(billing, titles[0])
      } else if (titles.length > 1) {
        const title = titles.find(item => item.taxAccount === buyerTaxAccount)
        if (title) {
          invoiceTitleUuid = title.uuid
          setBillingTitle(billing, title)
        } else {
          invoiceTitleUuid = titles[0].uuid
          setBillingTitle(billing, titles[0])
        }
      }
    } else {
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(billing.accountId))
      if (titleArray.length === 0) { // 没有维护开票抬头，取结算对象的
        // 根据结算对象ID获取结算对象
        billing.title = company ? company['chineseName'] : null
      } else { // 有维护，取默认的开票抬头
        for (const title of titleArray) {
          if (title.defaultTitle) {
            setBillingTitle(billing, title)
            invoiceTitleUuid = title.uuid
            break
          }
        }
      }
      // 获取开票要求
      if (company && !company.customerDetail) {
        await new Company(company).getCustomerDetail()
        if (company.customerDetail) {
          billing.invoiceDemand = company.customerDetail.invoiceRemarks || ''
        }
      }
    }
    // 获取开票抬头维护的开户银行信息
    await getTitleBankByTitle(billing, invoiceTitleUuid)
  })
}

export function setBillingTitle(billing, title) {
  if (!title) return
  billing.title = title.title || ''
  billing.invoiceMakeType = title.invoiceMakeType || ''
  billing.invoiceType = title.invoiceType || ''
  billing.buyerTaxAccount = title.taxAccount || ''
  billing.buyerAddress = title.address || ''
  billing.buyerTelephone = title.telephone || ''
  billing.customerEmail = title.email || ''
}

export async function getTitleBankByTitle(billing, invoiceTitleUuid = '') {
  if (!billing.title || !invoiceTitleUuid) return
  await getTitleBankList({ titleUuidList: [invoiceTitleUuid] }).then(res => {
    const titleBanks = res.data
    if (titleBanks && titleBanks.length > 0) {
      for (let i = 0; i < titleBanks.length; i++) {
        const bank = titleBanks[i]
        if (bank.defaultBank) {
          billing.buyerBank = bank.bank || ''
          billing.buyerBankAccount = bank.bankAccount || ''
          break
        }
      }
    }
  })
}
